/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { CmpStretchbadge } from "../CmpStretchbadge";
import "./style.css";

export const MobilityMiniCard = ({
  className,
  frameClassName,
  mobilityMiniCardClassName,
  vector = "/img/vector-2.svg",
  clipPathGroup = "/img/clip-path-group-1.png",
  img = "/img/vector-3.svg",
  elementMorningStretchClassName,
  spanClassName,
  spanClassNameOverride,
}) => {
  return (
    <div className={`mobility-mini-card ${className}`}>
      <div className={`frame ${frameClassName}`}>
        <div className={`div-2 ${mobilityMiniCardClassName}`}>
          <div className="stretch-icon">
            <div className="overlap-group">
              <img className="vector" alt="Vector" src={vector} />

              <img
                className="clip-path-group"
                alt="Clip path group"
                src={clipPathGroup}
              />

              <img className="img" alt="Vector" src={img} />
            </div>
          </div>

          <div className="element-morning-stretch-wrapper">
            <p
              className={`element-morning-stretch ${elementMorningStretchClassName}`}
            >
              <span className={`span ${spanClassName}`}>
                10m Morning Stretch
                <br />
              </span>

              <span className={`text-wrapper-3 ${spanClassNameOverride}`}>
                Daily Routine
              </span>
            </p>
          </div>

          <CmpStretchbadge className="cmp-stretchbadge-instance" />
        </div>
      </div>
    </div>
  );
};

MobilityMiniCard.propTypes = {
  vector: PropTypes.string,
  clipPathGroup: PropTypes.string,
  img: PropTypes.string,
};
